module.exports = __webpack_public_path__ + "b9d632faf18b2130c7b4ecbbb06a0bd7.woff2";